import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select"; // Import react-select
import { useForm } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";

function AddQuickbookVendor({ show, onClose, skuId, onVendorLinked }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    setValue,
  } = useForm();

  const [quickbookVendors, setQuickbookVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedVendorName, setSelectedVendorName] = useState(null);

  useEffect(() => {
    const quickbookVendorsData = JSON.parse(
      localStorage.getItem("quickbookVendors")
    );
    if (quickbookVendorsData) {
      setQuickbookVendors(quickbookVendorsData.data || []);
    }
  }, []);

  const { isLoading: createLoading, data: VendorData, postData: linkVendor } = usePostRequest(
    API_ENDPOINTS.LINK_QUICKBOOK_VENDOR
  );

  useEffect(() => {
    console.log("skuId", skuId);
  }, [skuId]);

  useEffect(() => {
    setSelectedVendorName(selectedVendor?.label || null);
  }, [selectedVendor]);

  useEffect(() => {
    if (selectedVendorName) {
      console.log("selectedVendorName", selectedVendorName);
    }
  }, [selectedVendorName]);

  const onSuccess = (res) => {
    toast.success(res?.message);
    if (onVendorLinked && selectedVendorName) {
      onVendorLinked(selectedVendorName);
    }
    onClose();
  };

  const onError = (err) => {
    toast.error(err?.message || "Error linking vendor");
    onClose();
  };

  const onSubmit = async (formData) => {
    try {
      const vendorAutoId = selectedVendor ? selectedVendor.value : null;
      const payload = {
        module_type: "ORDER", // add project here later
        vendor_auto_id: vendorAutoId,
        sku_id: skuId,
      };
      console.log("payload:", payload);
      linkVendor(payload, onSuccess, onError);
    } catch (err) {
      console.loh("Error linking vendor", err);
    }
  };

  const options = quickbookVendors.map((vendor) => ({
    value: vendor.auto_id,
    label: vendor.display_name,
  }));

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header className="justify-content-center d-block text-center" closeButton>
        <Modal.Title className="tittle_deal">
          Please choose a vendor
        </Modal.Title>
        <p className="mb-0">
          Please select a vendor before proceeding with the product selection.
          You can choose a vendor from the available options below.
        </p>
      </Modal.Header>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="required">Select Vendor</Form.Label>
            <Select
              options={options}
              //   onChange={(selectedOption) => setValue("vendor", selectedOption)}
              onChange={(selectedOption) => {
                setSelectedVendor(selectedOption);
                setValue("vendor", selectedOption);
              }}
              getOptionLabel={(e) => e.label}
              placeholder="Search for a vendor"
              isClearable
            />
            {errors.vendor && (
              <span className="text-danger">{errors.vendor.message}</span>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="warning" onClick={onSubmit} disabled={createLoading}>
            {createLoading ? "Submitting..." : "Confirm"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddQuickbookVendor;